import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/Accordion';
import { ArrowUpIcon, IntroIcon } from '@/components/Icons';
import { HistoryItem, Metadata } from '@/service/interface';
import dayjs from 'dayjs';
import CoverDefaultSrc from '@/assets/cover-default.png';

export const HistoryInfo = ({
  history = [],
  fetchSongDetail,
  currentMetadata,
}: {
  history: HistoryItem[] | undefined;
  fetchSongDetail: (params: { id: string }) => void;
  currentMetadata: Metadata;
}) => {
  const showTypeList = [currentMetadata?.type, ...(history?.map(({ metadata }) => metadata?.type) || [])];
  const showTimeList = [currentMetadata?.created_at, ...(history?.map(({ created_at }) => created_at) || [])];
  return (
    <div className=" mt-[16px] ">
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger className=" px-[16px] pr-[8px] h-[48px] border-t border-jen-border">
            <div className="  text-jen-size-heading-07 text-jen-content-tertiary">HISTORY</div>
          </AccordionTrigger>
          <AccordionContent className=" px-[16px]  pr-[8px] pb-[16px]  text-jen-content-secondary">
            {history?.map(({ name, id }, index) => {
              return (
                <>
                  <div>{dayjs(showTimeList[index]).format('HH:mm DD MMM YY')}</div>
                  <div key={id} className="border border-jen-border rounded-lg mt-[8px]">
                    <div className="text-jen-content-tertiary text-[12px] font-pressura-mono  h-[32px] px-[7px] py-[12px] flex  items-center pl-[12px] gap-[8px] border-b border-jen-border">
                      <IntroIcon fillColor="currentColor" />
                      {metadataTypeMapWord({ type: showTypeList[index] })}
                    </div>

                    <div
                      onClick={() => {
                        fetchSongDetail({ id });
                      }}
                      className=" cursor-pointer items-center  text-jen-content-secondary p-jen-spacing-8  flex gap-jen-spacing-12"
                    >
                      <img className="flex-shrink-0 w-[48px] h-[48px] rounded-md" src={CoverDefaultSrc} />
                      <div className="flex-1  truncate">{name}</div>
                      <ArrowUpIcon className="flex-shrink-0" />
                    </div>
                  </div>
                </>
              );
            })}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export const metadataTypeMapWord = ({ type }: { type: string }) => {
  return (
    {
      intro: 'INTRO ADDED FROM',
      trim: 'TRIMMED FROM',
      inpaint: 'REFILLED FROM',
      extend: 'EXTENDED FROM',
      outro: 'OUTRO ADDED FROM',
      fadeout: 'FADE OUT ADDED FROM',
    }[type] || 'INTRO ADDED FROM'
  );
};
